import { render, staticRenderFns } from "./bookTypeForm.vue?vue&type=template&id=ade21330&"
import script from "./bookTypeForm.vue?vue&type=script&lang=js&"
export * from "./bookTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports